import { nprogress } from '@mantine/nprogress';
import { useIsFetching } from '@tanstack/react-query';
import { useEffect } from 'react';

export function useProgressTracker() {
  const isFetching = useIsFetching();

  useEffect(() => {
    if (isFetching === 0) {
      nprogress.complete();
      return;
    }

    if (isFetching === 1) {
      nprogress.start();
      return;
    }

    nprogress.set(Math.max(0, Math.min(100, (1 / isFetching) * 100)));
  }, [isFetching]);
}
